import request from '@/utils/request'

let Job_infoApi = {

  /*岗位列表*/
  list(data) {
    return request._post('/shop/plus.job_info.Index/index', data);
},
/*添加岗位*/
add(data) {
    return request._post('/shop/plus.job_info.Index/add', data);
},
/*修改岗位*/
edit(data) {
    return request._post('/shop/plus.job_info.Index/edit', data);
},
/*删除岗位*/
del(data) {
    return request._post('/shop/plus.job_info.Index/del', data);
},
/*岗位详情*/
detail(data) {
  return request._post('/shop/plus.job_info.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.job_info.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.job_info.Setting/getSetting', data, errorback);
    },
}
export default Job_infoApi;



// WEBPACK FOOTER //
// ./src/api/job_info.js